'use client';

/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, memo, PropsWithChildren, useEffect, useState } from 'react';
import { requestNextApi } from '@/utils/next-api';
import { TAuthSession } from '@/modules/auth/types';
import { MainSplashScreen } from '@/components/Splash';
import { useAuthCSRSession } from '@/modules/auth/hooks/AuthSession';
import { devLog } from '@/utils/dev';

const AuthSessionProvider = memo(
  ({ children }: PropsWithChildren): JSX.Element => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { setSession } = useAuthCSRSession();

    useEffect(() => {
      (async function () {
        try {
          const data: TAuthSession = await requestNextApi('auth/session', {
            method: 'POST',
          });
          setSession(data);
        } catch (e) {
          devLog('session:error', e);
        } finally {
          setIsLoading(false);
        }
      })();
    }, []);

    return isLoading ? <MainSplashScreen /> : <>{children}</>;
  }
);
AuthSessionProvider.displayName = 'AuthSessionProvider';
export default AuthSessionProvider;

export const AuthSessionConsumer: FC<PropsWithChildren> = ({ children }) => {
  const { getSession } = useAuthCSRSession();
  return getSession() ? <>{children}</> : null;
};
